import React from 'react';

import classes from  './Illustrations.scss';

import error404 from '../../../assets/illustrations/404-error.mp4';
import emptyFilter from '../../../assets/illustrations/no-results.mp4';
import flightSearch from '../../../assets/illustrations/flight-search.mp4';
import holidaySearch from '../../../assets/illustrations/holiday-search.mp4';
import hotelSearch from '../../../assets/illustrations/hotel-search.mp4';
import hotelComingSoon from '../../../assets/illustrations/hotel-coming-soon.mp4';

const illustrations = (props) => {

    let illustration = null;

    switch(props.type) {
        case '404':
            illustration = error404;
            break;
        case 'no-results':
            illustration = emptyFilter;
            break;
        case 'flight-search':
            illustration = flightSearch;
            break;
        case 'holiday-coming-soon':
            illustration = holidaySearch;
            break;
        case 'hotel-coming-soon':
            illustration = hotelComingSoon;
            break;
        case 'holiday-searching':
            illustration = holidaySearch;
            break;
        case 'hotel-searching':
            illustration = hotelSearch;
            break;
        default:
            illustration = error404;
    }

    return (
        <div className={`${classes.Wrapper} mx-auto`}>
            <video src={illustration} autoPlay loop className={`u-width100Percent u-height100Percent`}>
                <source src={illustration}/>
            </video>
        </div>
    );
}

export default illustrations;


// WEBPACK FOOTER //
// ./src/components/UI/Illustrations/Illustrations.js